import { post, upload, download } from '@/apis/http'
import store from '@/store'

//登录
export function login(data) {
    return post(`${store.state.config.SGKT_URL}/basedata/auth/login`, data)
  }

/**
 * @description: 	获取用户头像
 * @param {*}
 * @return {*}
 */
 export const getUserPhoto = () => `${store.state.config.SGKT_URL}/basedata/user/getUserPhoto/`;

 /**
 * @description: 查询字典数据
 * @param {*} data
 * @return {*}
 */
  export function getDictInfoListNnl(data) {
    return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/getDictInfoList`, data)
}

/**
 * @description: 上传附件
 * @param {*} data
 * @return {*}
 */
 export function saveDixNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recdix/saveDix`, data)
}

/**
 * @description: 查询附件列表
 * @param {*} data
 * @return {*}
 */
 export function queryDixList(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recdix/queryDixList`, data)
}
/**
 * @description: 查询附件列表(公开)
 * @param {*} data
 * @return {*}
 */
 export function queryDixListNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recdix/queryDixList`, data)
}

/**
 * @description: 修改附件
 * @param {*} data
 * @return {*}
 */
 export function updDixNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recdix/updDix`, data)
}

/**
 * @description: 删除附件
 * @param {*} data
 * @return {*}
 */
 export function delDixNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recdix/delDix`, data)
}

/**
 * @description: 导入推荐单位
 * @param {*} data
 * @return {*}
 */
 export function importWk(data) {
  return upload(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/importWk`, data)
}

/**
 * 导入专家
 * @param data
 * @returns {*}
 */
 export function importExpert(data) {
  return upload(`${store.state.config.SGKT_URL}/wkds/recUser/importExpert`, data)
}

/**
 * 导出推荐单位
 * @param data
 * @returns {*}
 */
 export function exportWkNnl(data) {
  return download(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/exportWk`, data)
}

/**
 * 专家数据导出
 * @param data
 * @returns {*}
 */
 export function exportSpecialNnl(data) {
  return download(`${store.state.config.SGKT_URL}/wkds/recUser/exportSpecial`, data)
}

/**
 * 选手数据导出
 * @param data
 * @returns {*}
 */
 export function exportPlayerNnl(data) {
  return download(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/exportWkStatePlayers`, data)
}

/**
 * 获取模板地址
 * @param data
 * @returns {*}
 */
 export function getCommonTempleteNnl(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/res/dict/getCommonTempleteNnl`, data)
}

/**
 *  根据字典类型查询字典信息
 */
 export function queryDictByTypeCodeNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/dict/queryDictByTypeCodeNnl`, data)
}

/**
 * @description: 查询学段
 * @param {*} data
 * @return {*}
 */
export function getStepNnl(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/step/getStepNnl`, data)
}

/**
 * @description: 查询学科
 * @param {*} data
 * @return {*}
 */
export function getCoursesNnl(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/course/getCoursesNnl`, data)
}

/**
 * 根据学段查询科目
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function getCoursesByPeriodIdNnl(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/course/getCoursesByPeriodId`, data)
}

/**
 * 根据学段，科目获取年级信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function getByGradeCourseKeyNnl(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/grade/getByGradeCourseKeyNnl`, data)
}

//获取图形验证码
export function getImgCodeNnl(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/code/getImgCodeNnl`, data)
}
// 获取租户信息
export function queryTenantByDomainUrlNnl(data) {
  return post(`${store.state.config.SGKT_URL}/open/tenant/queryTenantByDomainUrlNnl`, data)
}



// WEBPACK FOOTER //
// ./src/apis/common/index.js